import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CementoParametroDto } from '../models/parametro-cemento.dto';
import { ServerListQuery, ServerPaginatedResponse } from '../shared/table/models/admin-server-table.model';

@Injectable({
  providedIn: 'root',
})
export class CementoParametroApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}cemento/settings/`;

  listParams(query: ServerListQuery): Observable<ServerPaginatedResponse<CementoParametroDto>> {
    let params = new HttpParams()
      .set('page', query.page.toString())
      .set('page_size', query.pageSize.toString());

    if (query.search) {
      params = params.set('search', query.search);
    }

    if (query.ordering) {
      params = params.set('ordering', query.ordering);
    }

    return this.http.get<ServerPaginatedResponse<CementoParametroDto>>(this.baseUrl, { params });
  }

  updateParam(id: number, data: Partial<CementoParametroDto>): Observable<CementoParametroDto> {
    return this.http.put<CementoParametroDto>(`${this.baseUrl}${id}/`, data);
  }
}
